var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { createUseStyles } from "react-jss";
import { classNames } from "./utils/classNames";
import { setIcon } from "./utils/icons";
import { THEME } from "./theming/theming";
import { useIconClasses } from "./theming/icons";
import { Mode } from "./types";
export var TextStyleOptions;
(function (TextStyleOptions) {
    TextStyleOptions["Bold"] = "bold";
    TextStyleOptions["LineThrough"] = "lineThrough";
})(TextStyleOptions || (TextStyleOptions = {}));
export var BodyText = function (_a) {
    var message = _a.message, glyph = _a.glyph, className = _a.className, glyphColor = _a.glyphColor, disabled = _a.disabled, lineThrough = _a.lineThrough, _b = _a.mode, mode = _b === void 0 ? Mode.Light : _b, textStyle = _a.textStyle, role = _a.role, hideMessage = _a.hideMessage;
    var _c = setIcon(glyph), iconType = _c.iconType, iconValue = _c.iconValue;
    var classes = useBodyTextClasses(disabled, lineThrough, mode, textStyle, hideMessage);
    var iconClasses = useIconClasses(iconType, mode === Mode.Dark ? THEME.palette.gray.white.color : glyphColor, hideMessage);
    if (iconType && iconValue) {
        return (React.createElement("span", { className: classNames(classes.bodyText, "body-text", className || ""), "aria-disabled": disabled !== null && disabled !== void 0 ? disabled : undefined, role: role !== null && role !== void 0 ? role : undefined },
            React.createElement("span", { className: classNames(iconClasses.icon, iconType, "".concat(iconType, "-").concat(iconValue)) }),
            React.createElement("span", { className: classNames("body-text--message", classes.message) }, message)));
    }
    return (React.createElement("span", { className: classNames(classes.bodyText, "body-text", className || ""), "aria-disabled": disabled !== null && disabled !== void 0 ? disabled : undefined, role: role !== null && role !== void 0 ? role : undefined }, message));
};
var BASE_BODY_TEXT = {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "row",
    minHeight: 20,
    height: "100%",
};
var useBodyTextClasses = function (disabled, lineThrough, mode, textStyle, hideMessage) {
    var color = disabled
        ? THEME.palette.gray.smoke.color
        : mode === Mode.Dark
            ? THEME.palette.gray.white.color
            : THEME.palette.gray.slate.color;
    var useStyles = createUseStyles({
        bodyText: __assign(__assign({}, BASE_BODY_TEXT), { color: color, textDecoration: lineThrough || (textStyle === null || textStyle === void 0 ? void 0 : textStyle.lineThrough) ? "line-through" : null, fontWeight: (textStyle === null || textStyle === void 0 ? void 0 : textStyle.bold) ? 500 : null, "& a": {
                color: color,
                textDecoration: "underline",
            }, "& a:hover": {
                color: color,
                textDecoration: "none",
            }, "& p": {
                marginBottom: 0,
            } }),
        message: __assign({ flex: 1 }, (hideMessage
            ? {
                position: "absolute",
                left: -10000,
                top: "auto",
                width: 1,
                height: 1,
                overflow: "hidden",
            }
            : {})),
    });
    return useStyles();
};
